import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, switchMap, of } from 'rxjs';
import { NsideIdentityService } from './nSideIdentityService';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NsideIdentityGuard implements CanActivate {

  constructor(
    private identity: NsideIdentityService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.identity.isAuthenticated().pipe(
      switchMap(isAuth => {
        if (!isAuth) {
          // Not authenticated → redirect to Identity Gateway login
          const redirectTarget = `${environment.angularAppUrl}${state.url}`;
          const redirectParam = encodeURIComponent(redirectTarget);
          window.location.href = `${environment.identityUrl}/login?redirect=${redirectParam}`;
          return of(false);
        }

        // Authenticated → ensure we have an API token
        if (this.identity.isTokenValid()) {
          return of(true);
        }

        // Fetch API token before allowing navigation
        return this.identity.fetchApiToken().pipe(
          map(token => {
            // Allow access even if token fetch fails (fallback to cookie auth)
            return true;
          })
        );
      })
    );
  }
}
